Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Table = void 0;

var core_1 = require("@emotion/core");

var core_2 = require("@wheelroom/core");

var table_row_1 = require("../table-row/table-row");

exports.Table = function (props) {
  var tableRows = props.tableRows;

  if (!tableRows) {
    return null;
  }

  var maxRowTopics = 0;
  tableRows.map(function (tableRow) {
    if (tableRow.topics && Array.isArray(tableRow.topics) && tableRow.topics.length > maxRowTopics) {
      maxRowTopics = tableRow.topics.length;
    }
  });
  return core_1.jsx(core_2.Box, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style
    })
  }, core_1.jsx(core_2.Table, {
    wheel: Object.assign(Object.assign({}, props.wheel), {
      style: props.wheel.style.tableElement
    })
  }, core_1.jsx("tbody", null, tableRows.map(function (tableRow, index) {
    return core_1.jsx(table_row_1.TableRow, {
      data: props.data,
      key: index,
      maxRowTopics: maxRowTopics,
      tableRow: tableRow,
      topicOptions: props.topicOptions,
      wheel: props.wheel
    });
  }))));
};